import React from "react";

const ErrorMessage = ({ id, errorClass, message }) => {
  return (
    <div id={id} className={errorClass}>
      {message}
    </div>
  );
};

export default ErrorMessage;
